import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { SendingState } from '@app-types/common';

@Component({
  selector: 'app-sending-state-button',
  templateUrl: './sending-state-button.component.html',
  styleUrls: ['./sending-state-button.component.scss'],
  imports: [TranslateModule, MatIconButton, MatTooltip, MatIcon],
})
export class SendingStateButtonComponent {
  @Input() state?: SendingState;
  constructor() {}
}
